export const signInUserData = [
    {
        id: '21',
        avatar: '/img/avatars/thumb-1.jpg',
        userName: 'Carolyn Perkins',
        email: 'carolyn.p@elstar.com',
        authority: ['admin', 'user'],
        password: '123Qwe',
        accountUserName: 'admin'
    },
    {
        id: '22',
        avatar: '/img/avatars/thumb-2.jpg',
        userName: 'Manager User',
        email: 'manager@salesworkx.com',
        authority: ['manager'],
        password: '12345',
        accountUserName: 'manager@salesworkx.com'
    },
    {
        id: '23',
        avatar: '/img/avatars/thumb-3.jpg',
        userName: 'Regular User',
        email: 'user@salesworkx.com',
        authority: ['user'],
        password: '12345',
        accountUserName: 'user@salesworkx.com'
    }
]